module.exports = __webpack_public_path__ + "static/media/Decoration_FoodTruck.85713d9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/themedEvent/decorations/Decoration_FoodTruck.png
// module id = 1348
// module chunks = 3